// Случайный циклический сдвиг порядка ходов (кто получает инициативу первым
// в начале матча). Должен считаться здесь, ДО вызова startGame(...), а не
// внутри редьюсера START_GAME: этот action переигрывается при воспроизведении
// записи матча (REPLAY), и повторный расчет внутри редьюсера бросал бы кубик
// заново, получая другой порядок ходов, чем в оригинальной партии.
export const getRandomInitiativeShift = (playerCount) => Math.floor(Math.random() * playerCount);
